export class TreeViewNode {
  id?:string;
  label?: string;
  randomColor?: string;
  type?: string;
  expanded?: boolean;
  locations?: string;
  ngClass?: string;
  children?: TreeViewChildren[];
  visibility?: boolean;
  itemData?: any;
}

export class TreeViewChildren {
    id?: string;
    label?: string;
    randomColor?: string;
    type?: string;
    code?:  string;
    quantity?: string;
    licensePlate?:string;
    img?:string;
    expanded?:boolean;
    children?:TreeViewChildren[];
    itemData?: any;
    buildingTag?:string;
  }